import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ConfigService } from '../shared/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {
  private apiUrl = '';

  constructor(private http: HttpClient, private configService: ConfigService) {
    // Assuming backend is running on same host, or we can use the config base URL
    // We'll construct the URL using the window location or config
    const baseUrl = this.configService?.apiBaseURL || `${window.location.protocol}//${window.location.host}/api/v3`;
    this.apiUrl = `${baseUrl}/cookie-consent`;
  }

  // Generate a UUID for the anonymous visitor
  private generateVisitorId(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  public getVisitorId(): string {
    let visitorId = localStorage.getItem('visitorId');
    if (!visitorId) {
      visitorId = this.generateVisitorId();
      localStorage.setItem('visitorId', visitorId);
    }
    return visitorId;
  }

  public getUserId(): number | null {
    const userIdStr = localStorage.getItem('UserId') || localStorage.getItem('userId');
    return userIdStr ? parseInt(userIdStr, 10) : null;
  }

  public getPolicyVersion(): Observable<string> {
    return this.http.get<any>(`${this.apiUrl}/version`).pipe(
      map(res => res?.responseBody?.version || 'v1.0'),
      catchError(() => of('v1.0'))
    );
  }

  public checkConsentStatus(policyVersion: string): Observable<boolean> {
    const payload = {
      user_id: this.getUserId(),
      visitor_id: this.getVisitorId(),
      policy_version: policyVersion
    };

    return this.http.post<any>(`${this.apiUrl}/status`, payload).pipe(
      map(res => res?.responseBody?.hasConsented || false),
      catchError(() => of(false))
    );
  }

  public saveConsent(consentStatus: 'accepted' | 'rejected', policyVersion: string): Observable<any> {
    const payload = {
      user_id: this.getUserId(),
      visitor_id: this.getVisitorId(),
      consent_status: consentStatus,
      policy_version: policyVersion
    };

    return this.http.post<any>(`${this.apiUrl}/save`, payload);
  }
}
